class Errors {
  errors: any;
  children: any;
}

export class FormErrors {
  errors: Errors
}
